import { ethers } from "ethers";

// for huge numbers
export const normalizeEther = (number: number | string, digits: number = 4) => {
  if (!number) return 0;
  try {
    return parseFloat(Number(ethers.utils.formatEther(number)).toFixed(digits));
  } catch (e) {
    return parseFloat(Number(number).toFixed(digits));
  }
};

// for small numbers
export const normalizeNumber = (
  number: number | string,
  digits: number = 4
) => {
  if (!number) return 0;
  return parseFloat(Number(number).toFixed(digits));
};
